var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.8887,
    r: 14,
    stroke: "#FFFEFA",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95508 17.8256C8.45066 17.8256 8.05515 17.6708 7.76855 17.3613C7.48195 17.0518 7.33865 16.6333 7.33865 16.106C7.33865 15.5786 7.48195 15.1602 7.76855 14.8507C8.05515 14.5411 8.45066 14.3864 8.95508 14.3864H13.1509V10.2937C13.1509 9.61736 13.3171 9.11867 13.6496 8.79768C13.9935 8.47669 14.4578 8.31619 15.0425 8.31619C15.6271 8.31619 16.0857 8.47669 16.4181 8.79768C16.7621 9.11867 16.934 9.61736 16.934 10.2937V14.3864H21.1298C21.6343 14.3864 22.0298 14.5411 22.3164 14.8507C22.603 15.1602 22.7463 15.5786 22.7463 16.106C22.7463 16.6333 22.603 17.0518 22.3164 17.3613C22.0298 17.6708 21.6343 17.8256 21.1298 17.8256H16.934V21.9182C16.934 22.5946 16.7621 23.099 16.4181 23.4315C16.0857 23.7525 15.6271 23.913 15.0425 23.913C14.4578 23.913 13.9935 23.7525 13.6496 23.4315C13.3171 23.099 13.1509 22.5946 13.1509 21.9182V17.8256H8.95508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLine);
export default __webpack_public_path__ + "static/media/add_line.c54d472e84dbe4b35522ac467709d49b.svg";
export { ForwardRef as ReactComponent };